import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "mdbreact/dist/css/mdb.css";
import { MDBCard, MDBCardBody, MDBCardTitle } from "mdbreact";

import Slider from "./Slider";
import HomeCardDeck from "./HomeCardDeck";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: true,
    };
  }
 
  render() {
    return (
      <div
      className="cardeck_full"
      
    >
      <div
      className="carddeck_inner"
        style={{
          // paddingTop: "0px",
          // paddingRight: "10px",
          // paddingBottom: "10px",
          // paddingLeft: "10px",
          backgroundColor: "#f0f5ff",
        }}
      >
       
        
          <Slider />
          <HomeCardDeck />
          <div style={{ padding: "10px" }}>
            <MDBCard style={{ width: "100%", textAlign: "justify" }}>
              <MDBCardBody>
                <MDBCardTitle style={{ color: "blue" }}>Glaciers</MDBCardTitle>
                {/* <MDBCardText style={{align:"justify"}}> */}
                Glaciers are made up of snow over longer period of time by
                compression resulting in to large, thickened ice masses. Every
                year, new layers of snow bury the old layers, forcing the snow
                to transform slowly from smaller grains to larger snow grains,
                causing the snow to compact and increase in density. After about
                few winters, the snow turns into firn, an intermediate state
                between snow and glacier ice, and finally that firn becomes ice.
                These glaciers move down the slopes under the influence of its
                own weight and gravity. Presently, glaciers occupy about 10
                percent of the world's total land area, with most located in
                polar regions like Antarctica, Greenland, and the Canadian
                Arctic. Most glaciers lie within mountain ranges that show
                evidence of a much greater extent during the ice ages of the
                past two million years, and more recent indications of retreat
                in the past few centuries. There are an estimated 54,000
                glaciers in the Hindu Kush Himalayas. These glaciers cover
                60,000 sq.km and serve as a major source of the water in the
                region’s rivers, including as much as 40 percent in the Indus
                River system. The glaciers are categorised in to various types
                based on their form, frontal and longitudinal characteristics
                such as valley glaciers, mountain glacier, cirque, niche, etc.
                Valley glaciers are the common type of glaciers in Indian
                Himalayas.
                {/* </MDBCardText> */}
                {/* <div style={{align:"right"}}><h6 >Read More</h6></div> */}
              </MDBCardBody>
            </MDBCard>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;
